module.exports = __webpack_public_path__ + "img/reviews_stats2.e635a518.png";